"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinPriceFilter = exports.MaxPriceFilter = exports.ProductFilter = exports.CategoryFilter = void 0;
/**
 * <h4>Recommendation filtering</h4>
 *
 * You can add to placement filters.
 * It allows you to filter products into a specific category
 * It allows you to filter products into a specific price between min and max price
 * Recommendations in the context of a product should contain the id of the product for which the
 * recommendation will be generated. For example, to get a list of products similar to product A,
 * provide the product ID of A.
 * @packageDocumentation
 */
var CategoryFilter_1 = require("./CategoryFilter");
Object.defineProperty(exports, "CategoryFilter", { enumerable: true, get: function () { return CategoryFilter_1.CategoryFilter; } });
var ProductFilter_1 = require("./ProductFilter");
Object.defineProperty(exports, "ProductFilter", { enumerable: true, get: function () { return ProductFilter_1.ProductFilter; } });
var MaxPriceFilter_1 = require("./MaxPriceFilter");
Object.defineProperty(exports, "MaxPriceFilter", { enumerable: true, get: function () { return MaxPriceFilter_1.MaxPriceFilter; } });
var MinPriceFilter_1 = require("./MinPriceFilter");
Object.defineProperty(exports, "MinPriceFilter", { enumerable: true, get: function () { return MinPriceFilter_1.MinPriceFilter; } });
//# sourceMappingURL=index.js.map